"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLevelManager = exports.MULTIPLIER_DECIMALS = void 0;
var react_1 = require("react");
var hooks_1 = require("../../shared/hooks");
var _abi_1 = require("../../abi");
// Multiplier support 4 decimals. To get a real number X = contractMultiplier / 1000;
exports.MULTIPLIER_DECIMALS = 1000;
function useLevelManager(forceAddress, forceVersion) {
    var _a = (0, hooks_1.useRegistryContractAddress)('levelManager'), addresses = _a.addresses, registryVersion = _a.version;
    var web3 = (0, hooks_1.useWeb3Provider)().web3;
    var address = forceAddress || addresses[0];
    var version = (forceVersion || registryVersion);
    var levelManager = (0, react_1.useMemo)(function () {
        return web3 && address
            ? new web3.eth.Contract(_abi_1.CONTRACTS.levelManager[version].abi, address)
            : undefined;
    }, [web3, address, version]);
    return { levelManager: levelManager, version: version };
}
exports.useLevelManager = useLevelManager;
